import { render, staticRenderFns } from "./OrganizationsFilters.vue?vue&type=template&id=68b51ac6&scoped=true&"
import script from "./OrganizationsFilters.vue?vue&type=script&lang=js&"
export * from "./OrganizationsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b51ac6",
  null
  
)

export default component.exports